import React, { useState } from "react";
import "../../styles/admins/inventory.css";
import axios from "axios";
import RiseTicket from "../clients/rise_ticket";

function AddTicket(props) {
const [selectedUser, setSelectedUser] = useState(null);
  const [users, setUsers] = useState([]);
  const today = new Date().toISOString().split("T")[0];
const doShow = props.clientData && props.clientData.is_admin !== 'Techie' && props.clientData.is_admin !== null;
  

// const [showPopup, setShowPopup] = useState(false);

  const [formData, setFormData] = useState({
    name: props.editProd.name || "",
    barcode: props.editProd.barcode || "",
    category: props.editProd.category || "Hardware",
    subCategory: props.editProd.sub_category || "",
    serialNumber: props.editProd.serial_no || "",
    ssdHdd: props.editProd.ssd_hdd || "",
    processor: props.editProd.processor || "",
    remarks: props.editProd.remarks || "",
    availabilityStatus: props.editProd.stats || "Available",
    purchaseDate: props.editProd.pur_date || today,
    expiryDate: props.editProd.expiry_date || "",
    version: props.editProd.vers_proc || "",
    ramConfiguration: props.editProd.key_ram || "",
    licenseType: props.editProd.lic_type_storage || "",
    macAddress: props.editProd.mac_no_users || "",
    user_name: props.editProd.user_name || "",
    added_by: props.clientData.company_id,
  });

  const [nameSuggestions, setNameSuggestions] = useState([]);

  const [subCatSuggestions, setSubCatSuggestions] = useState([]);

//   const handleSelect = (name, value) => {
//     setFormData({ ...formData, [name]: value });
//     setShowNameDrop(false);
//     setShowSubCatDrop(false);
//   };

  useState(() => {
        const getCompanies = async () => {
      try {
        const storedUsers = localStorage.getItem("users");

        if (storedUsers) {
          setUsers(JSON.parse(storedUsers));
        } else {
          const response = await axios.get(
            "https://api.dectwinservices.com/api/get-user"
          );

// if (props.doEdit === 'Techie' || props.doEdit === 'Admin') {
  const filteredUsers = response.data.filter(user =>
    (user.company_id === props.clientData.comp_id || user.company_id === props.clientData.company_id) &&
    user.id !== props.clientData.id
  );
  setUsers(filteredUsers);
  localStorage.setItem("users", JSON.stringify(filteredUsers));
// }

        //   else {
        //   setUsers(response.data);
        //   localStorage.setItem("users", JSON.stringify(response.data));
        //   }

        }
      } catch (e) {
        props.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };

  
        getCompanies();
    // getProducts();
  });


  return (
    <section className="px-32">
      <div className="d-flex justify-between">
        <div className="d-flex">
          {!doShow ? (
            <i className="bx bxs-customize" style={{ fontSize: "24px" }}></i>
          ) : (
            <i className="bx bxs-plus-circle" style={{ fontSize: "24px" }}></i>
          )}
          <p className="fw-bolder fs-big">
            &nbsp;
            {!doShow
              ? "Raise A Ticket"
              : Object.keys(props.editProd).length === 0
              ? "Add New Product"
              : `Edit Product "${props.editProd.name}"`}
          </p>
        </div>
   
      </div>


{!doShow && (
  <>
  <div className="assigned-row">
<br />


<div className="form-data" style={{margin: '0em 1em'}}>
              <label htmlFor="title">Select User</label>
  <div className="input-icon">
<select
  value={selectedUser?.id || ""}
  required
  onChange={async (e) => {
    const selectedUserId = e.target.value;
    const selectedUserObj = users.find(user => user.id == selectedUserId);

    setSelectedUser(selectedUserObj);

    setFormData((prev) => ({
      ...prev,
      user_name: selectedUserObj?.name || "",
    }));

    try {
      const response = await axios.get(
        `https://api.dectwinservices.com/api/user-product/${selectedUserId}`
      );

      if (response.data.length > 0) {
        const product = response.data[0];
        setFormData({
          name: product.name || "",
          barcode: product.barcode || "",
          category: product.category || "Hardware",
          subCategory: product.sub_category || "",
          serialNumber: product.serial_no || "",
          ssdHdd: product.ssd_hdd || "",
          processor: product.processor || "",
          remarks: product.remarks || "",
          availabilityStatus: product.stats || "Available",
          purchaseDate: product.pur_date || today,
          expiryDate: product.expiry_date || "",
          version: product.vers_proc || "",
          ramConfiguration: product.key_ram || "",
          licenseType: product.lic_type_storage || "",
          macAddress: product.mac_no_users || "",
          user_name: product.user_name || "",
          added_by: props.clientData.company_id,
        });
      } else {
        props.handleToast({
          toastMsg: "No product found for this user.",
          toastColor: "#FFA500",
        });
      }
    } catch (err) {
      props.handleToast({
        toastMsg: "Failed to fetch product for user.",
        toastColor: "#FF0000",
      });
    }
  }}
>
  <option value="">Select a user</option>
  {users.map((user) => (
    <option key={user.id} value={user.id}>
      {user.name}
    </option>
  ))}
</select>

  </div>
</div>


<RiseTicket
  product={formData}
  user={selectedUser || props.clientData}
  compId = {props.clientData.company_id}
  handleToast={props.handleToast}
  isTech={true}
/>

  </div>
  </>
)}

    </section>
  );
}

export default AddTicket;
